import React from 'react';
import ConfirmUserUpdate, {ProgressHeader} from '../ConfirmUserUpdate';
import {Alert, Button, FormGroup, Label} from "reactstrap";
import TTLProxy from "../../common/TTLAsyncProxy";
import {UsersEndpoints} from "../../common/ProxyEndpoints";
import Utils from "../../common/Utils";
import PropTypes from 'prop-types';
import * as Yup from "yup";
import HTML from '../../common/HtmlHelpers';
import MDProgress from "react-md-progress-bar";
import {ErrorMessage, Field, Form, Formik} from "formik";
import TokenInput from "../TokenInput/TokenInput";
import CodeInputView from "../CodeInputView/CodeInputView";

const TOKEN_LENGTH = 6;

class ChangeEmail extends React.Component{

    static  propTypes = {
        onChanged: PropTypes.func,
        closeAfterChanged: PropTypes.bool
    };

    static defaultProps = {
        closeAfterChanged: true
    };

    constructor(props){
        super(props);

        this.state = ChangeEmail.getInitialState();
        this.proxy = TTLProxy.getInstance();

        this.EmailValidationSchema = Yup.object().shape({
            email: Yup.string().email().required('Enter a valid email')
        });

        this.ConfirmationValidationSchema = Yup.object().shape({
            code: Yup.string().required('Enter the confirmation code received').min(TOKEN_LENGTH)
        });

    }

    static getInitialState(){

        return {
            hasInput: false,
            email: "",
            confirmationCode: "",
            confirmHintOpen: true,
            isBusy: false,
            errorMessage: null,
            agree: false
        };

    }

    show(){

        this.setState(ChangeEmail.getInitialState(),() => {
            this._confirmEmailChange.show();
        });

    }

    onChangeEmail({ email }){

        this.setState({
            isBusy: true,
            errorMessage: null,
            email
        });

        return this.proxy.processRequest( UsersEndpoints.confirmEmail(email) ).then(response => {

            //
            if(response.ok){

                this.setState({
                    hasInput: true,
                    errorMessage: null
                });

            }

            this.setState({
                isBusy: false
            });

        }).catch(err  =>{

            this.setState({
                errorMessage: Utils.getResponseError(err),
                hasInput: false,
                isBusy: false
            });

        });

    }

    onConfirmEmailChange({ code }){

        const newEmail = this.state.email;
        const token = code;

        this.setState({
            isBusy: true,
            errorMessage: null
        });

        return this.proxy.processRequest(UsersEndpoints.changeEmail(token,newEmail)).then(response =>{

            if(response.ok){

                HTML.toastSuccess('Email changed successfully');

                if(this.props.onChanged)
                    this.props.onChanged();

                if(this.props.closeAfterChanged)
                    this._confirmEmailChange.toggle();

            }

            this.setState({
                isBusy: false
            });

        }).catch(err => {


            this.setState({
                isBusy: false,
                errorMessage: Utils.getResponseError(err)
            });


        });

    }


    renderTokenConfirm(){

        return (<Formik initialValues={{ code: '' }}
                        key="token-confirm-form"
                        validationSchema={this.ConfirmationValidationSchema}
                        onSubmit={async (values,{ setSubmitting}) =>{

                            try{
                                await this.onConfirmEmailChange(values);
                            }
                            catch (e) {

                            }

                            setSubmitting(false);
                        }}>

            {({ isValid , isSubmitting }) => (<Form className="animated fadeIn" key="confirmForm">

                <ProgressHeader title={"Confirmation"} step={2} maxSteps={2}/>
                <Alert color={"info"} isOpen={this.state.confirmHintOpen} toggle={() => this.setState({ confirmHintOpen: !this.state.confirmHintOpen })}><b>Info:</b> You've been sent a confirmation code</Alert>
                <FormGroup>
                    <CodeInputView name="code" size={0.9}/>
                </FormGroup>

                {this.state.errorMessage && <p className="error-label">{this.state.errorMessage}</p>}


                <div>
                    {this.state.isBusy && <MDProgress show={true}/>}
                    <Button type="submit" block disabled={!isValid || this.state.isBusy} style={{borderRadius: 5}} color="green">Confirm <i className="fa fa-check"></i></Button>
                </div>

            </Form>)}
        </Formik>);


    }

    renderEnterInput(){

         return <Formik initialValues={{ email: "" }}
                        key="enter-email-form"
                        validationSchema={this.EmailValidationSchema}
                        ref={r => this._enterEmailForm = r}
                        onSubmit={async (values,{ setSubmitting }) => {

                            try {
                                await this.onChangeEmail(values);
                            }
                            catch (e) {

                            }

                            setSubmitting(false);
                        }}>
             {({ isValid , isSubmitting , errors  , touched }) => (<Form  key="inputForm">

                 <ProgressHeader title={"Enter Email"} step={1} maxSteps={2}/>
                 <p>Please enter your email for verification. You'll be sent a confirmation code shortly for completing the process</p>

                 <FormGroup>
                     <Label><i className="fa fa-envelope"></i> Email</Label>

                     <Field name="email" type="email"
                            placeholder="Enter your new email here..."
                            className={"form-control form-input-select " + ((errors.email && touched.email) ? "form-input-error" : "")}/>

                     <ErrorMessage name={"email"} component={"div"} className={"error-hint"}/>
                 </FormGroup>

                 {this.state.errorMessage && <p className="error-label">{this.state.errorMessage}</p>}

                 <div>
                     {this.state.isBusy && <MDProgress show={true}/>}
                     <Button type="submit" block disabled={!isValid || this.state.isBusy} style={{borderRadius: 5}} color="green">Verify <i className="icon-arrow-right"></i></Button>
                 </div>

             </Form>)}

         </Formik>;
    }

    render(){

        const { agree } = this.state;
        return <ConfirmUserUpdate title="Change Email Wizard"
                                  showCancelButton={false}
                                  ref={r => this._confirmEmailChange = r}>

            {!agree ? <form className="text-center p-lg-4" onSubmit={(evt) => {
                evt.preventDefault();
                this.setState({
                    agree: true
                });
            }}>

                <span><i className="fa fa-envelope fa-4x"/></span><br/>
                <b>Change Email</b>
                <p className="mt-2">In order to change your current email, we'll need to verify its ownership</p>

                <div style={{backgroundColor: "#ececec" , padding: 10 , marginBottom: 5}}>
                    Click the button below to begin...
                </div>

                <div className="text-center mt-2">

                    <Button block color={"green"}>Begin <i className="icon-arrow-right"/></Button>

                </div>

            </form>: (this.state.hasInput ?  this.renderTokenConfirm() : this.renderEnterInput())}

        </ConfirmUserUpdate>

    }

}

export default ChangeEmail;


// WEBPACK FOOTER //
// ./src/components/ConfirmUserUpdate/ChangeEmail.js